'use client'

import Link from 'next/link'
import { useEffect, useRef } from 'react'
import './index.css'


export default function XingmoH5() {
  const videoRef = useRef<HTMLVideoElement>(null)

  const busLink = '/introduce#apply-form'

  const homeLink = 'https://ai.wenkoo.com.cn/ai-journal/?tid=2001558202349912066#/detail?id=2001558202349912066'

  const payLink = 'https://ai.wenkoo.com.cn/ai-journal/?tid=2001558202349912066#/pay/list?id=2001558202349912066'

  useEffect(() => {



    // 微信环境下的视频自动播放处理
    const doPlay = () => {




      if (videoRef.current) {



        // 确保视频静音
        videoRef.current.muted = true
        videoRef.current.volume = 0

        // 尝试播放
        const playPromise = videoRef.current.play()
        if (playPromise !== undefined) {
          playPromise.catch(err => {
            console.log('视频自动播放失败:', err)
          })
        }
      }
    }

    const handleWeixinPlay = () => {
      if (typeof window !== 'undefined' && (window as any).WeixinJSBridge) {
        (window as any).WeixinJSBridge.invoke('getNetworkType', {}, doPlay)
      }
    }

    if (typeof window !== 'undefined') {
      // 监听页面可见性变化，确保视频持续播放
      const handleVisibilityChange = () => {
        if (!document.hidden && videoRef.current && videoRef.current.paused) {
          doPlay()
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange)

      // 微信环境处理
      if ((window as any).WeixinJSBridge) {
        handleWeixinPlay()
      } else {
        document.addEventListener('WeixinJSBridgeReady', handleWeixinPlay, false)
      }

      // 页面加载后尝试播放（针对非微信环境）
      setTimeout(doPlay, 100)

      // 降级方案：监听用户触摸事件触发播放
      const handleTouchStart = () => {
        setTimeout(() => {
          if (videoRef.current && videoRef.current.paused) {
            doPlay()
          }
        }, 50)
      }

      window.addEventListener('touchstart', handleTouchStart, { once: true })

      return () => {
        document.removeEventListener('WeixinJSBridgeReady', handleWeixinPlay)
        document.removeEventListener('visibilitychange', handleVisibilityChange)
        window.removeEventListener('touchstart', handleTouchStart)
      }
    }
  }, [])

  return (
    <div className="xingmo-mobile" style={{ 'maxWidth': '430px', margin: '0 auto' }}>
      <div className="top-nav">
        <div className="nav-content">
          <div className="nav-logo"></div>
          {/* <div className="nav-arrow"></div> */}
        </div>
      </div>

      <div className="main-container">
        <section className="hero-section">
          <h1 className="hero-title">省 80% 批改时间，让学生的每一篇作文获得精准指导</h1>
          <p className="hero-subtitle">改成教师不用熬夜逐句改，学生拿到能落地的提分方案，在这个时代之前教育者和学习者从未有过这样的机会。教师不再有心无力，学生也不再无助</p>

          <div className="button-group">
            <Link href={homeLink} target='_blank' className="btn btn-primary">
              <span className="btn-label">教师专属</span>
              <span className="btn-sublabel">免费领 1 次精准批改体验</span>
            </Link>

            <Link href='/introduce' className="btn btn-outline">
              <span className="btn-label">了解机构版</span>
              <span className="btn-sublabel">年级组一起省时间</span>
            </Link>
          </div>

          <p className="terms-text">注册即表示您同意<a href="#" className="terms-link">条款与条件</a>和<a href="#" className="terms-link">隐私政策</a>。</p>
        </section>

        <section className="section">
          <div className="video-container" style={{ width: '100%', borderRadius: 'var(--radius-large)', overflow: 'hidden', marginBottom: 'var(--spacing-4xl)' }}>
            <video
              ref={videoRef}
              muted
              loop
              playsInline
              webkit-playsinline="true"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="false"
              x5-playsinline="true"
              preload="auto"
              x5-video-orientation="portrait"
              poster="/images/xingmo/img/video4.001@2x.png"
              x-webkit-airplay="true"
              onLoadedMetadata={(e) => {
                const video = e.currentTarget;
                video.muted = true;
                video.volume = 0;
              }}
              style={{ width: '100%', height: 'auto', display: 'block' }}
              id="myVideo"
            >
              <source src="/images/xingmo/video-dec19.mp4" type="video/mp4" />
              您的浏览器不支持视频播放。
            </video>
          </div>
        </section>

        <section className="section magazine-section">
          <h2 className="section-description" style={{ textAlign: 'center' }}>230家权威作文刊物、超过300万篇范文</h2>
          <div className="magazine-grid">
            <div className="magazine-row">
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
            </div>
            <div className="magazine-row">
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
              <div className="magazine-item"></div>
            </div>
            <div className="magazine-mask"></div>
          </div>
        </section>

        <section className="section">
          <h2 className="section-title">写作<br />从理解题目开始</h2>
          <p className="section-description">对标考题拆解，学生审题不跑题</p>

          <div className="card">
            <div className="card-header success"></div>
            <div className="card-content">
              <img src="/images/xingmo/small00001.png" alt="写作指导" className="card-image" />
            </div>
          </div>
        </section>

        <section className="section">
          <h2 className="section-title">批改不止打分：<br />帮你把<span style={{ color: 'var(--color-primary)' }}>&ldquo;哪里不好&rdquo;</span>变成<span style={{ color: 'var(--color-primary)' }}>&ldquo;怎么改好&rdquo;</span>，省掉二次讲解的时间</h2>
          <p className="section-description">客观评价学生写作的优点与不足，不能止步于单纯的优劣评判，更要向学生拆解评价背后的逻辑；给出的建议也不能流于表面，而是要帮助学生精准定位问题根源，让他们不仅清楚问题所在，更能切实把握下一次写作的提升契机。</p>

          <div className="card">
            <div className="card-header info"></div>
            <div className="card-content">
              <img src="/images/xingmo/small00002.png" alt="批改不止打分" className="card-image" />
            </div>
          </div>
        </section>

        <section className="section">
          <h2 className="section-title">教师不用写教案：<br />修改范文 + 实操方法，直接给学生</h2>
          <p className="section-description">引导学生将修改意见与写作建议落到实处，为他们展示高水平应用的具体成果与实操方法；写作指导不能只批判，不示范。</p>

          <div className="card">
            <div className="card-header info"></div>
            <div className="card-content">
              <img src="/images/xingmo/small00003.png" alt="教师修改文" className="card-image" />
            </div>
          </div>
        </section>

        <section className="section">
          <h2 className="section-title">知其所以然</h2>
          <p className="section-description">对示范文本展开针对性解读，使文本的内涵得到更充分的理解，引导学生精准把握写作思路与表达技巧，为自主创作筑牢基础。</p>

          <div className="card">
            <div className="card-header warning"></div>
            <div className="card-content">
              <img src="/images/xingmo/small00004.png" alt="知其所以然" className="card-image" />
            </div>
          </div>

          <div className="radar-container" style={{ marginTop: 'var(--spacing-4xl)' }}>
            <h3 className="radar-title">作文分析雷达图</h3>
            <div className="radar-chart" style={{ backgroundImage: "url('/images/xingmo/rongqi7023@2x.png')", backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', marginBottom: 'var(--spacing-xl)' }}>
            </div>
            <div className="radar-legend" style={{ backgroundImage: "url('/images/xingmo/rongqi7206@2x.png')", backgroundSize: '138px 17px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', height: '17px', width: '138px', margin: '0 auto' }}>
            </div>
          </div>
        </section>

        <section className="section">
          <h2 className="section-title">更严谨的AI</h2>
          <p className="section-description">所有的方法论必须符合行墨专家组的框架，参考内容不会以整个互联网，而是从专家批改库和经过三审三校的优秀作文文章，保障建议的正确性、正能量、安全性的保障</p>

          <div className="image-section">
          </div>
        </section>

        <section className="section">
          <h2 className="section-title center">选择适合的套餐计划</h2>

          <div className="pricing-card recommended">
            <div className="recommended-badge"></div>
            <h3 className="plan-name">行墨个人版</h3>
            <p className="plan-description">个性化名师指导作文批改报告，基于名师教师批改库和230种作文期刊的范文库</p>

            <div className="price-container">
              <span className="price-symbol">￥</span>
              <span className="price-amount">198</span>
            </div>
            <p className="original-price">
              <span style={{ textDecoration: 'line-through' }}>原价 ￥498</span>，
              <span style={{ textDecoration: 'none', fontWeight: 600 }}>限时-￥300</span>
            </p>

            <Link href={payLink} className="btn btn-primary">
              <span className="btn-label">购买</span>
            </Link>

            <div className="pricing-features">
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">每月30次批改</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">5个作文智能体</span>
              </div>
            </div>
          </div>

          <div className="pricing-card">
            <h3 className="plan-name">免费版</h3>
            <p className="plan-description">大模型能力 + 专业知识库，模拟名师个性化辅导学生作文能力</p>

            <div className="price-container">
              <span className="price-symbol">￥</span>
              <span className="price-amount">0</span>
            </div>

            <Link href={homeLink} className="btn btn-outline">
              <span className="btn-label">免费体验</span>
            </Link>

            <div className="pricing-features">
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">每月5次批改</span>
              </div>
            </div>
          </div>

          <div className="pricing-card">
            <h3 className="plan-name">行墨校园机构版</h3>
            <p className="plan-description">以AI赋能作文教学，附赠优质期刊资源，北师大二附中、清华附中等名校已率先启用</p>

            <Link href={busLink} className="btn btn-dark">
              <span className="btn-label">联系我们</span>
            </Link>

            <div className="pricing-features">
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">班级创建和长期提升分析</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">支持批量上传</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">支持全班报告一键打印</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">支持微信和钉钉和SSO登陆</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon"></div>
                <span className="feature-text">获赠龙源校园作文期刊阅览室</span>
              </div>
            </div>
          </div>
        </section>

        <section className="results-section">
          <h2 className="results-title">平均提升学生作文水平</h2>
          <div className="results-percentage">10%</div>
          <p className="results-description">使用行墨的机构版，学生的中文写作成绩平均每年可提升 10%。数据全程私密安全，学习效率同步提高，不必要的沟通冗余减少，学生能更专注于内容本身，而非纠结文字的表达形式。</p>

          <div className="results-buttons">
            <Link href='/introduce' className="btn btn-white">
              <span className="btn-label">了解行墨机构版</span>
            </Link>
            <Link href={busLink} className="btn btn-white-outline">
              <span className="btn-label">联系销售</span>
            </Link>
          </div>
        </section>

        <section className="section">
          <h2 className="section-title">行墨<br />让你的工作学习事半功倍</h2>
          <p className="section-description">深耕十余年的AI写作领军者，凭借成熟技术与专业能力为你赋能，优化工作流程，大幅提升效率，助力高效达成目标</p>

          <div className="button-group">
            <Link href={homeLink} className="btn btn-primary">
              <span className="btn-label">免费注册</span>
            </Link>
            <p className="terms-text">注册即表示您同意<a href="#" className="terms-link">条款与条件</a>和<a href="#" className="terms-link">隐私政策</a>。</p>
          </div>
        </section>
      </div>
    </div>
  )

}
